<div>
  <h3 nz-typography class="nfl-form-label">Review & Summary</h3>

  <!-- Create Collaboration Section -->
  <nz-collapse>
    <nz-collapse-panel
      nzHeader="Create Collaboration"
      [nzExtra]="extraTemplate1"
      [nzActive]="createCollaborationExpanded"
      [nzShowArrow]="true"
      (nzActiveChange)="createCollaborationExpanded = $event"
    >
      <div class="collaboration-details">
        <div class="detail-item">
          <div class="nfl-form-label">Name</div>
          <p nz-typography>{{ collaborationDetails.name }}</p>
        </div>
        <div class="detail-item">
          <div class="nfl-form-label">Description</div>
          <p nz-typography>{{ collaborationDetails.description }}</p>
        </div>
        <div class="detail-item full-width">
          <div class="nfl-form-label">Objective</div>
          <p nz-typography>{{ collaborationDetails.objective }}</p>
        </div>
      </div>
    </nz-collapse-panel>

    <nz-collapse-panel
      nzHeader="Associate Dataset(s)"
      [nzExtra]="extraTemplate2"
      [nzActive]="datasetExpanded"
      [nzShowArrow]="true"
      (nzActiveChange)="datasetExpanded = $event"
    >
      <nz-table [nzData]="datasetDetails" [nzShowPagination]="false" [nzSize]="'small'" class="dataset-table">
        <thead>
          <tr>
            <th>
              <label nz-checkbox [ngModel]="true" nzDisabled="true"> </label>
            </th>
            <th>Connection Name</th>
            <th>Table Name</th>
            <th>Schema Name</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let dataset of datasetDetails">
            <td>
              <label nz-checkbox [ngModel]="true" nzDisabled="true"> </label>
            </td>
            <td>{{ dataset.dataConnectionName }}</td>
            <td>{{ dataset.tableName }}</td>
            <td>{{ dataset.schemaName }}</td>
            <td>
              <nz-tag nzColor="success">{{ dataset.status || 'Active' }}</nz-tag>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-collapse-panel>

    <nz-collapse-panel
      nzHeader="Partners & Invitations"
      [nzExtra]="extraTemplate3"
      [nzActive]="partnersExpanded"
      [nzShowArrow]="true"
      (nzActiveChange)="partnersExpanded = $event"
    >
      <div class="partner-details">
        <div class="detail-item full-width">
          <div class="nfl-form-label">Partners to Invite</div>
          <p nz-typography>{{ inviteDetails.partners }}</p>
        </div>
        <div class="detail-item full-width">
          <div class="nfl-form-label">Message</div>
          <p nz-typography>{{ inviteDetails.message }}</p>
        </div>
      </div>
    </nz-collapse-panel>
  </nz-collapse>
</div>

<ng-template #extraTemplate1>
  <span nz-icon nzType="edit" class="edit-icon" (click)="onEditSection('createCollaboration')"></span>
</ng-template>

<ng-template #extraTemplate2>
  <span nz-icon nzType="edit" class="edit-icon" (click)="onEditSection('dataset')"></span>
</ng-template>

<ng-template #extraTemplate3>
  <span nz-icon nzType="edit" class="edit-icon" (click)="onEditSection('partners')"></span>
</ng-template>
